import * as React from "react";
import Content from "../../../Content";
import Axios from "../../Components/Axios";
import {Link} from "react-router-dom";
import moment from "moment";

class KP extends React.Component{

    th() {
        return <tr>
                <th>ID</th>
                <th>Контент-провайдер</th>
                <th>MSISDN</th>
                <th>Дата добавления</th>
                <th>Пользователь</th>
                <th>Действие</th>
            </tr>;
    }

    header() {
        return <thead>{ this.th() }</thead>;
    }

    footer() {
        return <tfoot>{ this.th() }</tfoot>;
    }

    constructor(props) {
        super(props);
        this.state = { data: [] };
    }

    componentDidMount() {
        Axios
            .get('api/kp/list')
            .then(r => this.setState({ data: r.data }))
            .catch(() => this.props.history.push('/auth'));
    }

    render() {
        return (
            <Content title = "Управление КП">

                <div className="row mb-3">
                    <div className="col d-flex justify-content-between align-items-center">
                        <h5>Управление контент-провайдерами</h5>
                        <Link className="btn btn-success float-right" to={'kp/add'}>+ Добавить</Link>
                    </div>
                </div>
                <div className="table-responsive">
                    <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                        { this.header() }
                        { this.footer() }
                        <tbody>
                        {
                            this.state.data.map(e => (
                               <tr key={e?.id}>
                                   <td>{e?.id}</td>
                                   <td>{e?.title}</td>
                                   <td>{e?.kpMsisdn}</td>
                                   <td>{moment(e?.dateadd?.date).format('DD.MM.YYYY HH:mm:ss')}</td>
                                   <td>{e?.employe}</td>
                                   <td>
                                       <Link className="btn btn-info" to={`kp/edit/${e?.id}`}>Редактировать</Link>
                                   </td>
                               </tr>
                            ))
                        }
                        </tbody>
                    </table>
                </div>

            </Content>
        );
    }
}

export default KP;